/* eslint-disable no-var */
import React, { Component } from 'react';
import { Chart } from 'primereact/chart';
import { Buscar , graficoGerentes } from '../../services/contratos';

import { Card } from 'primereact/card';
import fundo_amarelo from '../../assets/fundo_amarelo.png';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import api from '../../services/backAxios/index';
import InputMask from 'react-input-mask';
import Organograma from '../organograma';
import { buscaHieraquia , BuscarAreaAtuacaoGerente } from '../../services/hierarquia';

import { Dialog } from 'primereact/dialog';
import { Link } from 'react-router-dom';
import * as moment from 'moment';
import { CalculoComissao } from '../../services/comissoes/index';
import { decriptObjectOnLocalStorage, decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';

let areaColaborador;
const vendedor = '';
const supervisor = '';
let tipoCodigo;
let dadosArea;
const meses = [
    '',
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
];

export default class graficoComprasGerente extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cod: '',
            nome: decriptoLocalStorage('Nome')?.decriptoValue,
            dados: [],
            dado: [],
            date: [],
            dato: [],
            data: [],
            mes: [],
            total: [],
            teste: '',
            totalRecebidos: '',
            totalEntregues: '',
            loading: 'loading',
            displayBasic: false,
            hierarquia: false,
            permissao: '',
            submit: '',
            token: '',
            vendedor: '',
            dataMes: '',
            dataAno: '',
            bodyVend: '',
            bodySupp: '',
            vendBody: '',
            vendBodyCod: '',
            supBody: '',
            codBody: '',
            comissao: '',
            totalPrime: ''
        };

        this.onClick = this.onClick.bind(this);
        this.onHide = this.onHide.bind(this);
        this.codigo = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;
    }

    async componentDidMount() {
        const area = decriptoLocalStorage('area');

        switch (area) {
        case '1':
            areaColaborador = 'EXTERNO';
            break;
        case null:
            areaColaborador = 'EXTERNO';
            break;
        case '2':
            areaColaborador = 'TELEMARKETING';
            break;
        case '3':
            areaColaborador = 'PRIME';
            break;
        case '4':
            areaColaborador = 'PDV';
            break;
        case '5':
            areaColaborador = 'TERCEIRIZADO';
            break;
        default:
            areaColaborador = 'PRIME';
        }

        this.permissao = decriptObjectOnLocalStorage('PERM');

        switch (this.permissao) {
        case '3':
            this.setState({ permissao: '/supervisor' });
            break;

        case '2':
            this.setState({ permissao: '/coordenador' });
            break;
        case '8':
            this.setState({ permissao: '/gerente' });
            break;
        case '1':
            this.setState({ permissao: '/vendedor' });
            break;
        default:
            this.setState({ permissao: '/gerente' });
            break;
        }

        this.setState({ loading: 'nada',
            submit: true });
        this.setState({ cod: this.codigo });
        setTimeout(() => {
            this.setState({ loading: 'nada',
                submit: true });
            this.busca(this.codigo);
        }, 2000);
        tipoCodigo = this.codigo;

        if (areaColaborador === 'PRIME') {
            if (this.permissao == 7) {
                await BuscarAreaAtuacaoGerente(3)
                    .then(response => {
                        dadosArea = response.Codigo;
                    })
                    .catch(err => {
                        console.error(err);
                    });
            }

            // A variável (tipoCodigo) indica o codigo do gerente para a analista comercial
            tipoCodigo = dadosArea ? dadosArea : this.codigo;
            await api
                .post('/gerente/graficos-gerente/prime')
                .then(resp => {
                    this.setState({ dados: resp.data });

                    const mes = resp.data.resultado.map(values => values.Mes);
                    const nomes = resp.data.resultado.map(values => values.Total);

                    this.setState({ totalPrime: nomes.slice(-1).pop() });
                    this.setState({ mes });
                    this.setState({ total: nomes });
                })
                .catch(err => {
                    console.log(err);
                });

            await graficoGerentes(tipoCodigo)
                .then(resp => {
                    this.setState({ date: resp['Vendedores'] });
                    this.setState({ dato: resp['Supervisores'] });
                    this.setState({ data: resp['Coordenadores'] });
                })
                .catch(err => {
                    console.log(err);
                });
        } else {
            await graficoGerentes(tipoCodigo)
                .then(resp => {
                    if(resp) {
                        this.setState({ dados: resp });
                        this.setState({ date: resp['Vendedores'] });
                        this.setState({ dato: resp['Supervisores'] });
                        this.setState({ data: resp['Coordenadores'] });

                        const mes = resp.resumo.map(values => values.mes);
                        const nomes = resp.resumo.map(values => values.total);

                        this.setState({ mes });
                        this.setState({ total: nomes });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }

    buscaTabela = async codigo => {
        await buscaHieraquia('/gerente', { Codigo: codigo })
            .then(result => {
                this.setState({ hierarquia: result });
            })
            .catch(error => {
                console.error(error);
                alert('Error ao carregar os dados!');
            });
    };

    onClick(name, position) {
        let state = {
            [`${name}`]: true
        };

        if (position) {
            state = {
                ...state,
                position
            };
        }

        this.setState(state);
    }

    onHide(name) {
        this.setState({
            [`${name}`]: false
        });
    }

    atualizarGraficos = () => {
        window.location.reload();
    };

    somaComicao = async () => {
        const dados = {
            Codigo: this.codigo,
            data_inicio: moment().format('YYYY-MM-01'),
            data_fim: moment().format('YYYY-MM-DD'),
            area: areaColaborador
        };

        await CalculoComissao ('gerente', dados)
            .then(resp=>{
                this.setState({ comissao: resp });
            }).catch (error => {
                console.err(error);
            });
    };

    busca = async codigo => {
        await Buscar(codigo, this.permissao)
            .then(response => {
                this.somaComicao();
                this.entregues();
                this.buscaTabela(codigo);
                //this.setState({ totalRecebidos: response })
            })
            .catch(function (erro) {
                this.entregues();
                this.setState({ loading: 'loading',
                    submit: true });
            });
    };

    entregues = async () => {
        this.buscaVend(this.codigo);
    };

    buscaVend = async tipoCodigo => {
        await graficoGerentes(tipoCodigo)
            .then(resp => {
                if(resp) {
                    this.setState({ dados: resp });
                    setTimeout(() => {
                        this.setState({ loading: 'loading',
                            submit: false });
                    }, 1000);
                    this.somaComicao();
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    updatedField(event) {
        const vendedorVendas = event.target.value;

        this.setState({ bodyVend: vendedorVendas });
    }

    async updatedField3(event) {
        const bodyVend = event.target.value ?
            event.target.value.toUpperCase() :
            event.target.value;

        this.setState({ vendBody: bodyVend });
    }

    async save3() {
        const digito = this.state.vendBody;
        const body = { vendedor: digito };
        const nomesVendedor = this.state.date.map(value => value.Nome);

        if (nomesVendedor.indexOf(digito) > -1) {
            const obj = await this.state.date.find(
                o => o.Nome === digito.toString()
            );

            await api
                .post(
                    `/coordenador/graficoCoordenadorNome/${obj['Coordenadore']['Codigo']}`,
                    body
                )
                .then(resp => {
                    this.setState({ date: resp.data });
                })
                .catch(err => {
                    console.log(err);
                });
        } else {
            await graficoGerentes(tipoCodigo)
                .then(resp => {
                    if(resp)  {this.setState({ date: resp['Vendedores'] });}
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }

    updatedField4(event) {
        const bodySup = event.target.value ?
            event.target.value.toUpperCase() :
            event.target.value;

        this.setState({ supBody: bodySup });
    }

    async save4() {
        const digito = this.state.supBody;
        const objeto = [];
        const nomeSupervisor = this.state.dato.map(value => value.Nome);

        if (nomeSupervisor.indexOf(digito) > -1) {
            const obj = await this.state.dato.find(
                o => o.Nome === digito.toString()
            );

            objeto.push(obj);

            if (obj) {
                this.setState({ dato: objeto });
            }
        } else {
            await graficoGerentes(tipoCodigo)
                .then(resp => {
                    if(resp) {this.setState({ dato: resp['Supervisores'] });}
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }

    updatedField5(event) {
        const enviarBody = event.target.value;
        const mes = enviarBody.substring(0, enviarBody.search('/'));
        const ano = enviarBody.substring(enviarBody.search('/') + 1);

        this.setState({ dataMes: mes });
        this.setState({ dataAno: ano });
    }

    updatedField6(event) {
        const bodyCod = event.target.value ?
            event.target.value.toUpperCase() :
            event.target.value;

        this.setState({ codBody: bodyCod });
    }

    async save6() {
        const digito = this.state.codBody;
        const objeto = [];
        const nomeCoordenador = this.state.data.map(value => value.Nome);

        if (nomeCoordenador.indexOf(digito) > -1) {
            const obj = await this.state.data.find(
                o => o.Nome === digito.toString()
            );

            objeto.push(obj);

            if (obj) {
                this.setState({ data: objeto });
            }
        } else {
            await graficoGerentes(tipoCodigo)
                .then(resp => {
                    if(resp)  {this.setState({ data: resp['Coordenadores'] });}
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }

    async save() {
        if (areaColaborador === 'PRIME') {
            let data;

            const body = {
                dataMes: this.state.dataMes,
                dataAno: this.state.dataAno
            };

            await api
                .post('gerente/graficos-gerente/prime', body)
                .then(resp => {
                    this.setState({ dados: resp.data });

                    const mes = [resp.data.resultado[0].Total];

                    const total = [resp.data.resultado[0].Total];

                    this.setState({ totalPrime: total[0] });
                    this.setState({ mes });
                    this.setState({ total });
                })
                .catch(err => {
                    this.busca(this.state.cod);
                    console.log(err);
                });
        } else {
            let data;

            if (this.state.dataMes && this.state.dataAno) {
                data = `${this.state.dataMes  }-${  this.state.dataAno}`;
            }

            const body = {
                dataRef: data,
                vendedor: this.state.bodyVend,
                supervisor: this.state.bodySupp
            };

            await api
                .post(`gerente/graficos-gerente-total-vendedor/${this.codigo}`, body)
                .then(resp => {
                    this.setState({ dados: resp.data });

                    const mes = resp.data.resumo.map(values => values.mes);

                    const total = [resp.data.Total];

                    this.setState({ mes });
                    this.setState({ total });
                })
                .catch(err => {
                    this.busca(this.state.cod);
                    console.log(err);
                });
        }
    }

    render() {
        let dados;
        var nomes = [];
        const metas = [];
        const total = 3120;
        const mes = this.state.mes;

        nomes = this.state.total;

        let meta;

        if (areaColaborador === 'PRIME') {
            meta = [744, 744, 744, 744];
        } else {
            meta = [1040, 1040, 1040, 1040];
        }

        const data = {
            labels: mes,
            datasets: [
                {
                    label: 'Vendas Aprovadas',
                    backgroundColor: '#F4C27A',
                    data: nomes
                },
                {
                    label: 'Metas de Venda',
                    backgroundColor: '#27348B',
                    data: meta
                }
            ]
        };

        const options = {
            title: {
                display: true,
                text: 'Venda nos ultimos meses',
                fontSize: 15
            },
            legend: {
                position: 'bottom',
                width: 1
            },
            barPercentage: 0.5,
            barThickness: 6,
            maxBarThickness: 8,
            minBarLength: 2,
            scales: {
                xAxes: [
                    {
                        stacked: false
                    }
                ],
                yAxes: [
                    {
                        stacked: false
                    }
                ]
            }
        };

        let mesTotal;

        if (areaColaborador === 'PRIME') {
            mesTotal = this.state.totalPrime;
        } else {
            mesTotal = this.state.dados.Total;
        }

        const options2 = {
            title: {
                display: true,
                text: `Total de Vendas Mês : ${mesTotal}`,
                fontSize: 15
            },
            legend: {
                position: 'bottom',
                width: 1
            },
            cutoutPercentage: 50,
            circumference: Math.PI,
            rotation: Math.PI
        };

        let meta2;

        if (areaColaborador === 'PRIME') {
            meta2 = mesTotal - 744;
        } else {
            meta2 = mesTotal - 1040;
        }

        const data2 = {
            labels: ['Total de vendas Mês', 'Metas Restantes'],
            datasets: [
                {
                    data: [mesTotal, meta2],
                    backgroundColor: ['#96C929']
                }
            ]
        };

        const dat = [];

        const vendedoresNome = this.state.date.map(value => {
            dat.push(78);

            return value['Nome'];
        });

        const data3 = {
            labels: vendedoresNome,
            datasets: [
                {
                    label: 'Vendas Aprovadas',
                    backgroundColor: '#F4C27A',
                    data: this.state.date.map(value => value.Total)
                },
                {
                    label: 'Metas de Venda',
                    backgroundColor: '#27348B',
                    data: dat
                }
            ]
        };

        const options3 = {
            title: {
                display: true,
                text: 'Vendas total por Vendedores',
                fontSize: 15
            },
            legend: {
                position: 'bottom',
                width: 1
            },
            barPercentage: 0.5,
            barThickness: 6,
            maxBarThickness: 8,
            minBarLength: 2,
            scales: {
                xAxes: [
                    {
                        stacked: false
                    }
                ],
                yAxes: [
                    {
                        stacked: false
                    }
                ]
            }
        };

        const tad = [];
        const supervisoresNome = this.state.dato.map(value => {
            tad.push(312);

            return value['Nome'];
        });

        const data4 = {
            labels: supervisoresNome,
            datasets: [
                {
                    label: 'Vendas Aprovadas',
                    backgroundColor: '#F4C27A',
                    data: this.state.dato.map(value => value.Total)
                },
                {
                    label: 'Metas de Venda',
                    backgroundColor: '#27348B',
                    data: tad
                }
            ]
        };

        const options4 = {
            title: {
                display: true,
                text: 'Vendas total por Coordenadores',
                fontSize: 15
            },
            legend: {
                position: 'bottom',
                width: 1
            },
            barPercentage: 0.5,
            barThickness: 6,
            maxBarThickness: 8,
            minBarLength: 2,
            scales: {
                xAxes: [
                    {
                        stacked: false
                    }
                ],
                yAxes: [
                    {
                        stacked: false
                    }
                ]
            }
        };

        const coordTotal = [];
        const coordenadoresNome = this.state.data.map(value => {
            coordTotal.push(312);

            return value['Nome'];
        });

        const data5 = {
            labels: coordenadoresNome,
            datasets: [
                {
                    label: 'Vendas Aprovadas',
                    backgroundColor: '#F4C27A',
                    data: this.state.dato.map(value => value.Total)
                },
                {
                    label: 'Metas de Venda',
                    backgroundColor: '#27348B',
                    data: coordTotal
                }
            ]
        };

        const options5 = {
            title: {
                display: true,
                text: 'Vendas total por Coordenadores',
                fontSize: 15
            },
            legend: {
                position: 'bottom',
                width: 1
            },
            barPercentage: 0.5,
            barThickness: 6,
            maxBarThickness: 8,
            minBarLength: 2,
            scales: {
                xAxes: [
                    {
                        stacked: false
                    }
                ],
                yAxes: [
                    {
                        stacked: false
                    }
                ]
            }
        };

        const header = <img alt="Card" src={fundo_amarelo} />;

        return (
            <>
                <div className={this.state.loading}>
                    <ProgressSpinner
                        style={{
                            width: '300px',
                            height: '150px',
                            display: 'flex',
                            margin: '0 auto',
                            marginTop: '8%'
                        }}
                        strokeWidth="1"
                        fill="#EEEEEE"
                        animationDuration=".5s"
                    />
                </div>
                {this.state.submit !== true ? (
                    <Card className='tratar-scroll-card' header={header} title="Home">
                        <div className="group">
                            <Button
                                label="Abrir Hierarquia"
                                onClick={() => this.onClick('displayBasic')}
                            />

                            <Dialog
                                header="Hierarquia"
                                visible={this.state.displayBasic}
                                style={{ width: '75vw' }}
                                maximizable
                                onHide={() => this.onHide('displayBasic')}
                            >
                                <Organograma
                                    dadosHierarquia={this.state.hierarquia}
                                />
                            </Dialog>
                            <br />
                            <Card>
                                <div className="p-grid">
                                    <h2 style={{ marginLeft: '30%' }}>
                                        <b>Vendas Gerais</b>
                                    </h2>
                                    <div className="p-col-12 p-md-12 p-lg-12">
                                        <label>
                                            <h3
                                                style={{
                                                    color: 'black',
                                                    marginBottom: '1%'
                                                }}
                                            >
                                                Filtrar Gráfico Geral
                                            </h3>
                                            <InputMask
                                                mask="99/9999"
                                                placeholder="Data ex:10/2020"
                                                maskChar={null}
                                                style={{ height: '33px' }}
                                                type="text"
                                                onChange={e =>
                                                    this.updatedField5(e)
                                                }
                                            />{' '}
                                            <a />
                                            <Button
                                                label="Filtrar Gráficos"
                                                onClick={() => this.save()}
                                            />
                                            <br />
                                            <br />
                                            <Button
                                                label="Atualizar Pagina"
                                                style={{
                                                    backgroundColor: '#E1E1E1',
                                                    borderColor: 'gray',
                                                    color: 'gray'
                                                }}
                                                onClick={() =>
                                                    this.atualizarGraficos()
                                                }
                                            />
                                        </label>
                                        {/**descomentar link quando homologado relatórios */}
                                        <Link to="/relatorioGerente">
                                            <a
                                                style={{
                                                    color: 'gray',
                                                    border: '1px solid gray',
                                                    borderRadius: '3px',
                                                    marginLeft: '4px'
                                                }}
                                                className="p-col-12 p-md-12 p-lg-12"
                                            >
                                                <i
                                                    className="pi pi-money-bill"
                                                    style={{ color: '#27348B' }}
                                                ></i>
                                                Comissão:{' '}
                                                {
                                                    this.state.comissao
                                                        .totalAdesao
                                                }
                                            </a>
                                        </Link>
                                    </div>
                                </div>
                                <br />
                                <div className="p-grid p-fluid">
                                    <div className="p-col-12 p-md-6 p-lg-6 p-sm-6">
                                        <Chart
                                            type="bar"
                                            data={data}
                                            options={options}
                                        />
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-6 p-sm-6">
                                        <Chart
                                            type="doughnut"
                                            options={options2}
                                            data={data2}
                                        />
                                    </div>
                                </div>
                            </Card>
                            <br />
                            <Card>
                                <h2 style={{ marginLeft: '30%' }}>
                                    <b>Vendas Coordenadores</b>
                                </h2>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label style={{ width: '100' }}>
                                        <h3
                                            style={{
                                                color: 'black',
                                                marginBottom: '1%'
                                            }}
                                        >
                                            Filtrar Gráfico Coordenador
                                        </h3>
                                        <InputText
                                            type="text"
                                            placeholder="Nome do Coordenador"
                                            onChange={e =>
                                                this.updatedField6(e)
                                            }
                                        />
                                        <Button
                                            type="submit"
                                            label="Filtrar"
                                            onClick={() => this.save6()}
                                        />
                                    </label>
                                </div>
                                <div className="p-grid p-fluid">
                                    <div className="p-col-11 p-md-11 p-lg-11 p-sm-11">
                                        <Chart
                                            type="bar"
                                            data={data5}
                                            options={options5}
                                        />
                                    </div>
                                </div>
                            </Card>
                            <br />
                            <Card>
                                <h2 style={{ marginLeft: '30%' }}>
                                    <b>Vendas Supervisor</b>
                                </h2>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label style={{ width: '100' }}>
                                        <h3
                                            style={{
                                                color: 'black',
                                                marginBottom: '1%'
                                            }}
                                        >
                                            Filtrar Gráfico Supervisor
                                        </h3>
                                        <InputText
                                            type="text"
                                            placeholder="Nome do supervisor"
                                            onChange={e =>
                                                this.updatedField4(e)
                                            }
                                        />
                                        <Button
                                            type="submit"
                                            label="Filtrar"
                                            onClick={() => this.save4()}
                                        />
                                    </label>
                                </div>
                                <div className="p-grid p-fluid">
                                    <div className="p-col-11 p-md-11 p-lg-11 p-sm-11">
                                        <Chart
                                            type="bar"
                                            data={data4}
                                            options={options4}
                                        />
                                    </div>
                                </div>
                            </Card>
                            <br />
                            <Card>
                                <h2 style={{ marginLeft: '30%' }}>
                                    <b>Vendas Vendedor</b>
                                </h2>
                                <div className="p-col-12 p-md-6 p-lg-6">
                                    <label style={{ width: '100' }}>
                                        <h3
                                            style={{
                                                color: 'black',
                                                marginBottom: '1%'
                                            }}
                                        >
                                            Filtrar Gráfico Vendedor
                                        </h3>
                                        <InputText
                                            type="text"
                                            placeholder="Nome do vendedor"
                                            onChange={e =>
                                                this.updatedField3(e)
                                            }
                                        />
                                        <Button
                                            label="Filtrar"
                                            onClick={() => this.save3()}
                                        />
                                    </label>
                                </div>
                                <div className="p-grid p-fluid">
                                    <div className="p-col-11 p-md-11 p-lg-11 p-sm-11">
                                        <Chart
                                            type="bar"
                                            data={data3}
                                            options={options3}
                                        />
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </Card>
                ) : null}
            </>
        );
    }
}
